import { render } from "./NavBar.vue?vue&type=template&id=64748dd6"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=64748dd6&lang=css"

import exportComponent from "/home/runner/work/tom/tom/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__